import React, { useEffect } from 'react';
import { styled } from '@material-ui/core/styles';

import Controls from '../components/Controls/Controls';
import LocalVideoPreview from '../components/LocalVideoPreview/LocalVideoPreview';
import MenuBar from '../components/MenuBar/MenuBar';
import ReconnectingNotification from '../components/ReconnectingNotification/ReconnectingNotification';
import Room from '../components/Room/Room';
import './App.css'

import useRoomState from '../hooks/useRoomState/useRoomState';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const Main = styled('main')({
  height: '100%',
  position: 'relative',
});

export default function App() {
  const roomState = useRoomState();

  return (
    <Container>
      <MenuBar />
      <Main className="main-container">
        {roomState === 'disconnected' ? <LocalVideoPreview /> : <Room />}
        <Controls />
      </Main>
      <ReconnectingNotification />
    </Container>
  );
}
